import {
  ConsultantLeaveCallListMutationVariables,
  useConsultantLeaveCallListMutation
} from "@bonliva-crm/graphql";
import { CallOrContactList, HookProps } from "../utils";

export function useConsultantLeaveCallList(props: HookProps) {
  const [consultantLeaveCallListMutation] = useConsultantLeaveCallListMutation({
    onError: (e) => {
      console.error(e);
      props.onError && props.onError(e);
    },
    onCompleted: (data) => {
      props.onCompleted && props.onCompleted();
    }
  });

  const consultantLeaveCallList = (
    args: ConsultantLeaveCallListMutationVariables & {
      affectedCallList: CallOrContactList;
    }
  ) => {
    const { affectedCallList, ...rest } = args;
    consultantLeaveCallListMutation({
      variables: rest,
      optimisticResponse: (vars) => {
        return {
          removeFromCallList: {
            __typename: "CallListOpResult",
            callList: {
              ...affectedCallList,
              nodes: affectedCallList.nodes.filter((node) => node.NodeID !== vars.nodeId)
            }
          }
        };
      }
    });
  };

  return { consultantLeaveCallList };
}
